import { Grid, Group, Button, useMantineTheme } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { memo } from "react";
import { InputMaybe, Scalars } from "src/generated/graphql";
import { date, object } from "yup";
import DatePicker from "src/components/DatePicker";
import {
  TimeDiffType,
  createDateTime,
  getDateDiff,
} from "src/utils/dateHelper";
import { errorNotification } from "src/utils/alerts";
import { useModals } from "@mantine/modals";
import { IChartFilter } from "src/api/context/DashboardContext";

type IFormProps = {
  endedAt: InputMaybe<Scalars["DateTime"]>;
  startedAt: InputMaybe<Scalars["DateTime"]>;
};

export const TimeClockEntryFormSchema = object().shape({
  startedAt: date().required("Start Date is required"),
  endedAt: date().required("End Date is required"),
});

interface IProps {
  filters: IChartFilter;
  setFilters: (e: IChartFilter) => void;
  minDate?: Date;
}

const DateRange = ({ filters, setFilters, minDate }: IProps) => {
  const modals = useModals();
  const theme = useMantineTheme();
  const form = useForm<IFormProps>({
    initialValues: {
      startedAt: filters?.dateRange?.[0] || null,
      endedAt: filters?.dateRange?.[1] || null,
    },
    validate: yupResolver(TimeClockEntryFormSchema),
  });

  const handleUpdate = async (values: IFormProps) => {
    let _start = createDateTime(
      values.startedAt,
      new Date(new Date().setHours(0, 0, 0, 0))
    );
    let _end = createDateTime(
      values.endedAt,
      new Date(new Date().setHours(23, 59, 59, 999))
    );
    let _diff = getDateDiff(_start, _end, TimeDiffType.seconds);

    if (_diff < 0) {
      return errorNotification({
        message: "Start Time must be less than End",
      });
    }
    try {
      setFilters({ ...filters, dateRange: [_start, _end] });
      modals.closeAll();
    } catch (e: any) {
      console.error("Error: ", e.response);
    }
  };

  return (
    <form onSubmit={form.onSubmit((values) => handleUpdate(values))}>
      <Grid justify="space-between">
        <Grid.Col span={12}>
          <DatePicker
            label="Start Date"
            maw={400}
            mx="auto"
            minDate={minDate}
            {...form.getInputProps("startedAt")}
          />
        </Grid.Col>
        {/* <Grid.Col span={6}>
          <TimeInput
            withSeconds
            label="Start Time"
            {...form.getInputProps("startedTime")}
          />
        </Grid.Col> */}
      </Grid>

      <Grid justify="space-between">
        <Grid.Col span={12}>
          <DatePicker
            label="End Date"
            maw={400}
            mx="auto"
            minDate={minDate}
            {...form.getInputProps("endedAt")}
          />
        </Grid.Col>
        {/* <Grid.Col span={6}>
          <TimeInput
            withSeconds
            label="End Time"
            {...form.getInputProps("endedTime")}
          />
        </Grid.Col> */}
      </Grid>

      <Group position="apart" mt="md" style={{ marginTop: 30 }}>
        <Button
          radius="md"
          variant="outline"
          onClick={() => modals.closeAll()}
          style={{
            flex: 1,
            color: theme.colors.secondaryTextColor[6],
          }}
          sx={{
            backgroundColor: theme.colors.secondary[6],
            "&:hover": {
              background: theme.colors.secondary[5],
            },
          }}
        >
          Cancel
        </Button>
        <Button
          radius="md"
          type="submit"
          style={{
            flex: 1,
          }}
          sx={{
            color: theme.colors.primaryTextColor[6],
            "&:hover": {
              backgroundColor: theme.colors.primary[4],
            },
          }}
        >
          Save
        </Button>
      </Group>
    </form>
  );
};

export default memo(DateRange);
